import { useAuthStore } from '@/stores/auth';
import axios from '@/utils/axios';
import { fetchWrapper } from '@/utils/helpers/fetch-wrapper';
import { store, key } from '@/storeVuex';
import { router } from '@/router';

export function Initialize() {
    const baseUrl = `${import.meta.env.VITE_API_URL_API}`;
    const user = store.state.user;

    // Sync Pinia auth store with Vuex store on initialization
    try {
        const authStore = useAuthStore();
        authStore.syncWithVuexStore();
    } catch (error) {
        console.error('Failed to sync auth stores:', error);
    }

    if (user) {
        if (user.user) {
            // Send CSRF token with userinfo request
            interface RequestData {
                _csrf?: string;
            }

            const requestData: RequestData = {};
            if (user.csrfToken) {
                requestData._csrf = user.csrfToken;
            }

            fetchWrapper
                .post(baseUrl + '/userinfo', requestData)
                .then(async (data) => {
                    await store.commit('refreshUserData', data);

                    // Also update Pinia store with refreshed data
                    try {
                        const authStore = useAuthStore();
                        authStore.syncWithVuexStore();
                    } catch (error) {
                        console.error('Failed to sync auth stores after refresh:', error);
                    }
                })
                .catch(async (err) => {
                    // fetchWrapper rejects with parsed JSON data, not a response object.
                    // Check for auth errors in the rejected data itself.
                    const isAuthError =
                        err?.message?.includes('Unauthenticated') ||
                        err?.error?.includes('Unauthenticated') ||
                        err?.error_code === 'IDLE_TIMEOUT' ||
                        (typeof err === 'string' && err.includes('Unauthenticated'));

                    if (isAuthError) {
                        console.warn('⚠️ Authentication error fetching user info — session may have expired.');
                        // fetchWrapper already handles 401/403 redirect, so this is
                        // for cases where the server returns 500 with auth-related message
                        await store.dispatch('logout');
                        localStorage.removeItem('projectselected');
                        localStorage.removeItem('weektimesheet');
                        localStorage.removeItem('projecttimesheet');
                        localStorage.removeItem('user');

                        try {
                            const authStore = useAuthStore();
                            authStore.logout();
                        } catch (error) {
                            console.error('Failed to clear Pinia auth store:', error);
                        }

                        router.push({ name: 'login' });
                    } else {
                        // For other errors (network, server), don't logout — just log
                        console.error('Failed to fetch user info:', err);
                    }
                });
        }
    }

    // axios.interceptors.response.use(function (response) {
    //     return response
    // }, function (error) {
    //     // if(error.message.includes('Unauthenticated')){
    //     //     store.logout();
    //     // }
    //     return Promise.reject(error)
    // })
}
